



export class OrganisationProfessionalVM {
    
    username?: string;
    
    createdOn?: Date;
    
    enabled?: boolean;
    
    disabledOn?: Date;
    
    isRegistered?: boolean;
    
    joiningCode?: string;
    
    joinedOn?: Date;
    
}
